import { Data, Model, Utils } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import LogCriteria from '../Models/Logging/LogCriteria';
import LogLookup from '../Models/Logging/LogLookup';

export interface ILogApiClient {

    /** 
     * Gets a page of logs from the database.
     */
    getLogs(request: Model.PartialPlainNonTrackedObject<Data.PageRequest<LogCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<LogLookup>>>;

    // Client only properties / methods
}

@injectable()
export default class LogApiClient extends Data.ApiClientBase implements ILogApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/logs`);
    }

    public getLogs(request: Model.PartialPlainNonTrackedObject<Data.PageRequest<LogCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<LogLookup>>> {
        return this.axios.get(`${this.apiPath}/paged?${Utils.getQueryString(request)}`);
    }

    // Client only properties / methods
}